

angular.module('sample.widgets.recentlyAwardedContracts',
      [
        'adf.provider',
        "ngResource",
        "LocalStorageModule",
        "EICDataStream3.resources",
        "ui.router",
        'ui.bootstrap.tooltip'
      ])
  .config(['dashboardProvider', function (dashboardProvider) {
    dashboardProvider
      .widget('recentlyAwardedContracts', {
        id: "recentlyAwardedContracts",
        title: 'Recently Awarded Contracts',
        description: 'A list of Contracts that  were awarded within the ast 14 days',
        controller: 'RecentlyAwardedContractsController',
        //   controllerAs: 'list',
        templateUrl: '/app-ds3/dashboard/widgets/recentlyAwardedContracts/recentlyAwardedContracts.partial.html' //,
        //            edit:         {
        //              templateUrl: '/app/angular-dashboard-framework/widgets/linklist/edit.html',
        //              reload:      false,
        //              controller:  'linklistEditCtrl'
        //            }
      });
  }])
  .controller('RecentlyAwardedContractsController', ['$scope', '$q', 'recentlyAwardedContracts', '$state', 'localStorageService', 'userAccessService', "lookupTables",
    function ($scope, $q, recentlyAwardedContracts, $state, localStorageService, userAccessService, lookupTables) {
      $scope.componentName = "RecentlyAwardedContractsController";
  var accessRequestCanceler = $q.defer();
  var recentlyAwardedContractsRequest = null;


      //    $scope.title = 'Recently Awarded Contracts';

      $scope.recentlyAwardedContracts = [];

      var sectorVisibility = function (sectorId) {
        if (!$scope.access) return false;
        return ($scope.access.accessType !== 'industry' ||
          $scope.access.allowedSectors.indexOf(sectorId) !== -1);
      };


      // fetch the list from the lookup tables endpoint
      // and transform it.
      lookupTables.industrySectors().$promise
        .then(function (sectors) {
          var allSectorIds = sectors.map(function (s) { return s.id; });

          // get the list of previously  selected sectors from a Local Storage.
          // if the selected list doesn't exist, set it to the whole list 
          var selectedSectors = localStorageService.get("dashboard.recentlyAwardedContractsEnergySectors") ||
            allSectorIds;

          var listItems = sectors.map(function (s) {
            return {
              text: s.name,
              value: s.id,
              selected: selectedSectors.indexOf(s.id) !== -1,
              visible: sectorVisibility
            };
          });

          var nameArray = [];
          sectors.forEach(function (s) {
            nameArray[s.value] = s.name;
          });


          $scope.energySectors = {
            listItems: listItems,
            selected: selectedSectors || [],
            names: nameArray
          };
        });


      userAccessService.getRights({ timeout: accessRequestCanceler.promise })
        .then(function (response) {
          $scope.access = response.data;
        });

      $scope.getRecentlyAwardedContracts = function () {
        recentlyAwardedContractsRequest = recentlyAwardedContracts.query({ days: 14 });
        $scope.recentlyAwardedContracts = recentlyAwardedContractsRequest;
      };


      $scope.selectContractAward = function (contractAward) {
        var newState = "search.contract";
        $state.go(newState, { contractID: contractAward.contractID, contractDescription: "/" + contractAward.shortContractType.urlEncode() });
      };


      var defaultSelectedSectors = [1, 2, 3, 4, 5, 6, 7, 8];

      $scope.$on('$viewContentLoaded', function () {
        $scope.getRecentlyAwardedContracts();
      });

      $scope.$emit('$viewContentLoaded', [1, 2, 3]);

      $scope.$on('$destroy', function () {
        accessRequestCanceler.resolve();
        if (recentlyAwardedContractsRequest && angular.isFunction(recentlyAwardedContractsRequest.$cancelRequest)) {
          recentlyAwardedContractsRequest.$cancelRequest();
        }
        localStorageService.set("dashboard.recentlyAwardedContractsEnergySectors", $scope.energySectors.selected, { expires: 28, expirationUnit: 'days' });
      });
    }]);

